// @flow

// inspired by
// https://material.io/design/color/the-color-system.html#color-theme-creation

const PRIMARY = '#13A89E';


const Theme = {
  boxShadow: '0 0 5px 0 rgba(90, 90, 90, 0.1)',

  colors: {
    age: '#6f30a4',
    background: '#F2F2F2',
    danger: '#c10000',
    divider: '#c8c8c8',
    error: '#c10000',
    female: '#f58497',
    form: {
      border: '#bbbbbb',
      dropdownHover: '#F5F5F5',
      fill: '#edf8f8',
      focused: PRIMARY,
    },
    gain: {
      normal: '#5b9b00',
      mediumLight: '#d0fdc5',
      light: '#f4fde9',
    },
    geolocation: '#6f30a4',
    listeningTime: '#ff5e00',
    loss: {
      normal: '#c10000',
      mediumLight: '#fde1e0',
      light: '#fde6e5',
    },
    male: '#80d9ff',
    overlay: '#F4F4F4',
    primary: {
      normal: PRIMARY,
      light: '#1ac5bb',
    },
    reach: '#1368a8',
    surface: '#FFFFFF',
    secondary: '#0071A6',
    table: {
      hover: '#00000012',
      hoverOnDark: '#00000024',
      separator: '#97979733',
    },
    text: {
      primary: '#4d4c4d',
      secondary: '#212121',
      surface: '#000000',
      tableHeader: '#21212199',
      formLabel: 'rgba(94, 94, 94, 0.6)',
      tertiary: '#FFF',
      title: '#494949',
      emphasis: '#4C4C4C',
    },
    warning: '#FF6F00',
  },

  fonts: {
    family: "'Lato', regular",

    metrics: {
      size: 26,
      letterSpacing: 0.375,
    },

    smallMetrics: {
      size: 20,
    },

    body: {
      size: 16,
      letterSpacing: 0.19,
    },
    button: {
      letterSpacing: 0.16,
      size: 12,
      weight: 600,
    },
    h1: {
      size: 32,
      letterSpacing: 0.375,
    },
    h2: {
      size: 24,
      letterSpacing: 0.285,
    },
    h3: {
      size: 21,
      letterSpacing: 0.255,
    },
    h4: {
      size: 16,
      letterSpacing: 0.195,
    },

    forms: {
      label: {
        size: 12,
        letterSpacing: 0.14,
      },
      input: {
        size: 16,
        letterSpacing: 0.16,
      },
    },
  },

  metrics: {
    borderRadius: 2,
    breakpoints: {
      small: 600,
      normal: 1200,
    },
    form: {
      border: {
        radius: 2,
        width: 1,
      },

      input: {
        height: 36,
        padding: 4,
      },
    },
    margin: {
      tiny: 4,
      small: 8,
      normal: 16,
      large: 32,
      huge: 64,
    },
    navbar: {
      height: 45,
      zIndex: 1100,
    },
    menu: {
      width: 256,
    },
    page: {
      x: 52,
      y: 40,
    },
    icon: {
      size: 24,
      frameSize: 48,
      framePadding: 12,
    },
  },
};

export default Theme;



// WEBPACK FOOTER //
// ./src/statsradio/themes/v3/Theme.js